import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';
import { setAbove } from 'pubweb-smokey/dist/components/zIndex';
import chZindex from '@components/zIndex';

const localZindex = {
  resultsInfo: setAbove(chZindex.filterBars),
  pagingBar: setAbove(),
  searchFilters: setAbove(),
  selectedMapPin: setAbove(),
};

export const LandSearchStyles = styled.div`
  .area-info {
    align-items: center;
    display: flex;
    height: 190px;
    justify-content: center;
  }

  .constrained-width {
    height: 100%;
  }

  .land-results {
    display: flex;
    flex-direction: row;
  }

  .listings-searching {
    align-items: center;
    display: flex;
    justify-content: center;
    height: calc(100vh - 160px);
    left: 0;
    position: absolute;
    width: 100%;
    top: 50px;
  }

  .listings-results {
    min-height: calc(100vh - 160px);

    &.searching {
      opacity: 0.25;
    }
  }

  .land-map {
    background-color: ${Colors.accent.grey7.standard};
    display: none;
    height: calc(100vh - 60px);
    position: sticky;
    top: 60px;
    width: 50%;
  }

  .map-pin-navigator {
    background: url('/public-assets/images/images/map-pin.svg') no-repeat;
    background-size: cover;
    cursor: pointer;
    color: #fff;
    width: 25px;
    height: 31px;

    .map-text {
      font-size: 12px;
    }

    &.selected {
      background: url('/public-assets/images/map-pin-selected.svg') no-repeat;
      background-size: cover;
    }
  }

  //pins on the map
  .map-pin {
    background: url('/public-assets/images/map-pin-sibling.svg') no-repeat;
    background-size: cover;
    cursor: pointer;
    color: #fff;
    width: 25px;
    height: 31px;

    .map-text {
      font-size: 12px;
    }

    //the currently selected pin
    &.selected {
      background: url('/public-assets/images/map-pin-selected.svg') no-repeat;
    }
  }

  .map-text {
    display: block;
    text-align: center;
    width: 100%;
    padding-top: 3px;
  }

  .search-parameters {
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 100%;
  }

  .search-pill {
    align-items: center;
    background-color: #fff;
    border: solid 1px #cacccf;
    border-radius: 100px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    padding: 0 12px;

    &.open {
      border-color: ${Colors.primary.claytonBlue.standard};
      color: ${Colors.primary.claytonBlue.standard};

      .standard {
        color: ${Colors.primary.claytonBlue.standard};
      }

      svg {
        * {
          fill: ${Colors.primary.claytonBlue.standard};
        }
      }
    }

    &.changed {
      background-color: ${Colors.primary.claytonBlue.standard};
      color: ${Colors.primary.white.standard};
    }
  }

  .dropdown-list {
    margin-bottom: 10px;

    li svg {
      margin-top: 5px;
    }
  }

  .within-miles {
    align-items: center;
    display: flex;
    flex-direction: row;

    & > span {
      font-family: 'source-sans-pro', sans-serif;
      margin: 0 5px 10px 5px;
    }

    .dropdown-list {
      width: 100px;
    }
  }

  .location-display,
  .price-display,
  .sort-display,
  .results-info,
  .results-number {
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 50px;
  }

  .results-info {
    background-color: ${Colors.primary.white.standard};
    border-bottom: 1px solid ${Colors.primary.black.tint};
    color: ${Colors.primary.white.tint};
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 25px;
    position: sticky;
    top: 60px;
    z-index: ${localZindex.resultsInfo};

    .sort-modal {
      width: 100%;

      .modal-window {
        left: auto;
        right: 25px;
        margin-top: 1px;
        padding-top: 10px;

        .anchored-modal-content {
          overflow-y: visible;
        }
      }
    }
    span {
      font-family: 'source-sans-pro', sans-serif;
    }
  }

  .sort-selected {
    color: ${Colors.primary.claytonBlue.standard};
    cursor: pointer;
    margin-left: 1em;
  }

  .location-display {
    margin-left: 10px;
    margin-right: 5px;
  }
  .price-display {
    margin-left: 5px;
    margin-right: 10px;
  }

  .price-dropdowns {
    align-items: center;
    display: flex;
    flex-direction: row;

    & > span {
      margin: 0 5px 10px 5px;
    }

    .dropdown-list {
      width: 100%;
    }
  }

  .land-search {
    align-items: center;
    background-color: ${Colors.primary.white.standard};
    border-bottom: 1px solid ${Colors.primary.black.tint};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 60px;
    overflow-x: auto;
    position: sticky;
    top: 0;
    white-space: nowrap;
    width: 100%;
    z-index: ${localZindex.searchFilters};
  }

  .left-scroll {
    align-items: center;
    background-color: rgba(255, 255, 255, 0.75);
    display: flex;
    height: 59px;
    justify-content: center;
    left: 0;
    margin-right: -30px;
    position: sticky;
    width: 30px;

    svg {
      height: 20px;
      margin-left: 10px;
      margin-top: 15px;
      width: 20px;
    }
  }

  .right-scroll {
    align-items: center;
    background-color: rgba(255, 255, 255, 0.75);
    display: flex;
    height: 59px;
    justify-content: center;
    margin-left: -30px;
    position: sticky;
    right: 0;
    width: 30px;

    svg {
      height: 20px;
      margin-left: 10px;
      margin-top: 15px;
      width: 20px;
    }
  }

  .land-modals {
    position: sticky;
    top: 61px;
    z-index: ${localZindex.searchFilters};

    .modal-window {
      margin-top: 1px;
      padding-top: 10px;
      width: 300px;

      .anchored-modal-content {
        overflow-y: visible;
      }
    }
  }

  .location-display {
    align-items: center;
    display: flex;
    flex-direction: row;

    svg {
      margin: 7px 2px 0 2px;
    }
  }

  .land-listings {
    width: 100%;

    a.listhub-terms:link,
    a.listhub-terms:visited,
    a.listhub-terms:hover,
    a.listhub-terms:active {
      color: ${Colors.primary.claytonBlue.standard};
      display: block;
      margin: auto;
      text-align: right;
      text-decoration: none;
      width: 86%;
    }
  }

  .location-modal {
    .auto-position .modal-window {
      left: 25px;
    }
  }

  .price-modal {
    .auto-position .modal-window {
      left: auto;
      right: 25px;
    }
  }

  .location-modal {
    .auto-position .modal-window {
      left: 10px;
    }
  }

  .price-modal {
    .auto-position .modal-window {
      left: auto;
      right: 10px;
    }
  }

  .results-footer {
    position: relative;
  }

  .listings-paging {
    align-items: center;
    background-color: ${Colors.primary.white.standard};
    border-top: 1px solid ${Colors.primary.black.tint};
    bottom: 0;
    color: ${Colors.primary.white.tint};
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 50px;
    padding: 0 25px;
    position: sticky;

    span {
      font-family: 'source-sans-pro', sans-serif;
    }

    svg {
      border: 1px solid #e4e5e7;
      border-radius: 75px;
      cursor: pointer;
      height: 35px;
      width: 35px;

      * {
        fill: ${Colors.primary.white.tint};
      }

      &:hover {
        border-color: ${Colors.primary.claytonBlue.standard};

        * {
          fill: ${Colors.primary.claytonBlue.standard};
        }
      }
    }

    .disabled svg {
      opacity: 0.5;
      pointer-events: none;
    }

    .left {
      margin-left: 25px;
      margin-right: 25px;

      svg {
        padding-left: 11px;
        padding-top: 8px;
      }
    }

    .right {
      margin-left: 25px;
      margin-right: 25px;

      svg {
        padding-left: 13px;
        padding-top: 8px;
      }
    }
  }

  .empty-results {
    align-items: center;
    display: flex;
    height: calc(100vh - 160px);
    justify-content: center;
    margin: auto;
  }

  @media screen and (min-width: 320) {
    .location-display {
      margin-left: 25px;
    }

    .price-display {
      margin-right: 25px;
    }

    .location-modal {
      .auto-position .modal-window {
        left: 25px;
      }
    }

    .price-modal {
      .auto-position .modal-window {
        left: auto;
        right: 25px;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .land-listings {
      width: 50%;
    }

    .land-map {
      display: block;
    }
  }
`;

export default LandSearchStyles;
